import request from '@/core/http/request'

// 查询产品委外订单
export function outsourcingDoc_vagueList(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsourcingDoc/vagueList',
        method: 'post',
        data: data
    })
}

// 产品委外详情
export function outsourcingDoc_view(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsourcingDoc/view',
        method: 'get',
        params: data
    })
}


// 查询产品委外发货
export function outsourcingtowarehouse_getVagueList(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsourcingtowarehouse/getVagueList',
        method: 'post',
        data: data
    })
}

// 查询产品委外退料
export function outsorReturnDoc_outsorReturnDocList(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsorReturnDoc/outsorReturnDocList',
        method: 'post',
        data: data
    })
}

// 查询产品委外收料
export function outsorRequisitionDoc_listTwo(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsorRequisitionDoc/listTwo',
        method: 'post',
        data: data
    })
}

export function outsorRequisitionDoc_view(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsorRequisitionDoc/view',
        method: 'get',
        params: data
    })
}



// 产品委外退料新增
export function outsorReturnDoc_add(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsorReturnDoc/add',
        method: 'post',
        data: data
    })
}

// 产品委外退料详情
export function outsorReturnDoc_view(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsorReturnDoc/view',
        method: 'get',
        params: data
    })
}

// 产品委外退料修改
export function outsorReturnDoc_update(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsorReturnDoc/update',
        method: 'post',
        data: data
    })
}

// 产品委外可退料数据
export function outsourcingDoc_getOutsourcingDoc(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsourcingDoc/getOutsourcingDoc',
        method: 'post',
        data: data
    })
}


// 产品委外发货新增
export function outsourcingtowarehouse_add(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsourcingtowarehouse/add',
        method: 'post',
        data: data
    })
}

// 产品委外发货修改
export function outsourcingtowarehouse_update(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsourcingtowarehouse/update',
        method: 'post',
        data: data
    })
}

// 产品委外发货删除
export function outsourcingtowarehouse_delete(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsourcingtowarehouse/delete',
        method: 'post',
        data: data
    })
}

// 产品委外发货详情
export function outsourcingtowarehouse_view(data) {
    return request({
        url: '/qingguang/cooperativesupplier/outsourcingtowarehouse/view',
        method: 'get',
        params: data
    })
}

// 工序委外订单列表 
export function processOutsourcing_list(data) {
    return request({
        url: '/qingguang/cooperativesupplier/processOutsourcing/list',
        method: 'post',
        data: data
    })
}

// 工序委外订单详情
export function processOutsourcing_view(data) {
    return request({
        url: '/qingguang/cooperativesupplier/processOutsourcing/view',
        method: 'get',
        params: data
    })
}

// 工序委外收料列表
export function processOutsourcingRequisitionDoc_listWithDetail(data) {
    return request({
        url: '/qingguang/cooperativesupplier/processOutsourcingRequisitionDoc/listWithDetail',
        method: 'post',
        data: data
    })
}

// 工序委外收料详情
export function processOutsourcingRequisitionDoc_view(data) {
    return request({
        url: '/qingguang/cooperativesupplier/processOutsourcingRequisitionDoc/view',
        method: 'get',
        params: data
    })
}

// 工序委外退料列表
export function processOutsourcingReturn_listWithMaterial(data) {
    return request({
        url: '/qingguang/cooperativesupplier/processOutsourcingReturn/listWithMaterial',
        method: 'post',
        data: data
    })
}

// 工序委外退料详情
export function processOutsourcingReturn_view(data) {
    return request({
        url: '/qingguang/cooperativesupplier/processOutsourcingReturn/view',
        method: 'get',
        params: data
    })
}

// 工序委外发货列表
export function processOutsourcingReceive_list(data) {
    return request({
        url: '/qingguang/cooperativesupplier/processOutsourcingReceive/list',
        method: 'post',
        data: data
    })
}

// 工序委外发货新增
export function processOutsourcingReceive_add(data) {
    return request({
        url: '/qingguang/cooperativesupplier/processOutsourcingReceive/add',
        method: 'post',
        data: data
    })
}

// 工序委外发货修改
export function processOutsourcingReceive_update(data) {
    return request({
        url: '/qingguang/cooperativesupplier/processOutsourcingReceive/update',
        method: 'post',
        data: data
    })
}

// 工序委外发货删除
export function processOutsourcingReceive_delete(data) {
    return request({
        url: '/qingguang/cooperativesupplier/processOutsourcingReceive/delete',
        method: 'post',
        data: data
    })
}

// 工序委外发货详情
export function processOutsourcingReceive_view(data) {
    return request({
        url: '/qingguang/cooperativesupplier/processOutsourcingReceive/view',
        method: 'get',
        params: data
    })
}

// 工序委外可发货信息
export function processOutsourcingReceive_processOutsourcingCanReceiveProduction(data) {
    return request({
        url: '/qingguang/cooperativesupplier/processOutsourcingReceive/processOutsourcingCanReceiveProduction',
        method: 'post',
        data: data
    })
  }